<template>
<div id="app">
    <div id="wrap">
        <div id="header" v-if="route_chk">
            <app-header />
        </div>
        <!-- <app-menu /> -->
        <popup-component ref="popup"/>
        <router-view />
        <div id="footer">
            <app-footer />
        </div>
        <div class="loading" v-if="loading">
            <img src="./assets/images/loading.gif" alt="loading"/>
        </div>
    </div>
</div>
</template>

<script>
import vue from 'vue';
import common from './js/common';
import * as config from './js/config';
import store from './js/store';

import './assets/js/jquery-3.5.1.min.js';
import './assets/js/index.js';

import AppHeader from './components/AppHeader';
import AppFooter from './components/AppFooter';
import AppMenu from './components/AppMenu';
import PopupComponent from './components/component/PopupComponent';

export default {
    name: 'App',
    components: {
        'app-header': AppHeader,
        'app-footer': AppFooter,
        'app-menu': AppMenu,
        'popup-component': PopupComponent
    },
    data() {
        return {
            route_chk:true,
            loading: this.$store.getters['getLoading'].value
        }
    },
    created(){
        this.$nextTick(function () {
            var self = this;
            var callback = function(message, result){
                // 자동로그인 설정이 되어있을 경우
                if(result.auto){
                    store.commit('setLoading', { value: true});
                    var data = {};
                    data.token = result.token;
                    
                    var type = config.REQ_USER_TOKEN_LOGIN;
                        store.dispatch(type.action_name, {
                            type: type,
                            data: data
                        }).then((response) => {
                            if(typeof response.userInfo == 'undefined'){
                                common.removeAutoLoginSetting();
                                self.$router.push('/');
                            }else{
                                if(response.token_refresh){
                                    common.autoLoginSetting(response.token);
                                }
                                store.commit('setUser_info', { value: response.userInfo });
                                store.commit('setLogin_chk', { value: true });
                                
                                self.$router.push('/');
                                store.commit('setLoading', { value: false});
                            }
                        }).catch(function (error) {
                            console.log('error=============>', error);
                        });
                }else{
                    if (self.$router.history.current.fullPath != '/') {
                        self.$router.push('/');
                        // this.$store.commit('setCurrentPage', {
                        //     value: '/home'
                        // });
                    } 
                    // common.removeAutoLoginSetting();
                }
            }
            common.autoLoginCheck(callback);
        });
    },
    mounted() {
        this.$nextTick(function () {
            
        });
    },
    methods: {
    },
    computed: {
        getLoading() {
            return this.$store.getters.getLoading.value;
        },
    },
    watch: {
        $route(to, from) {
            if (to.path != from.path) {
                /* router path가 변경될 때마다 접근로그를 저장한다. */
                this.$store.commit('setLastPage', {
                    value: from.path
                });

                this.$store.commit('setCurrentPage', {
                    value: to.path
                });

                document.documentElement.scrollTop = 0;
                if(to.path === '/regist' || to.path === '/findpw' ){
                    this.route_chk = false;
                }else{
                    this.route_chk = true;
                }
            }
        },
        getLoading(){
            this.loading = this.$store.getters.getLoading.value;
        }
    }
}
</script>

<style>
@import url('../src/assets/css/main.css');
@import url('../src/assets/css/reset.css');
@import url('../src/assets/css/mypage.css');
@import url('../src/assets/css/login.css');
@import url('../src/assets/css/popup.css');
@import url('../src/assets/plugin/slick/slick.css');
@import url('../src/assets/plugin/slick/slick-theme.css');
</style>



// WEBPACK FOOTER //
// src/App.vue